// extracted by mini-css-extract-plugin
module.exports = {"root":"accordion-icon_root__jMvUt","sizexl":"accordion-icon_sizexl__kb8yJ"};